'use client';
import React from 'react';
import Link from 'next/link';
import Image from 'next/image';

export default function ServicesSection() {
  return (
    <section id="services" className="section-pad overflow-hidden" style={{ backgroundColor: 'rgba(240,244,244,0.3)' }}>
      <div className="mx-auto max-w-6xl px-6">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-6">
          <div className="space-y-3">
            <span className="service-tag">What We Treat</span>
            <h2 className="text-section-xl font-display font-bold" style={{ color: 'var(--foreground)' }}>
              Every service,{' '}
              <span className="font-display italic text-gradient-gold">at your home</span>
            </h2>
          </div>
          <Link href="/services" className="btn-secondary text-sm self-start md:self-auto">
            View All Catalog
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" width="15" height="15">
              <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
            </svg>
          </Link>
        </div>

        {/* Bento Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {/* Orthopedic */}
          <div className="bento-card group overflow-hidden">
            <div className="relative h-36 rounded-xl overflow-hidden mb-4 -mx-1 -mt-1">
              <Image
                alt="Physiotherapist performing knee rehabilitation exercises with a patient in a home setting"
                src="/assets/images/orthopedics-1785953141994.jpeg"
                fill
                className="object-cover transition-transform duration-500 group-hover:scale-105"
                sizes="25vw" />
            </div>
            <div className="space-y-2">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-xl flex items-center justify-center" style={{ backgroundColor: 'var(--secondary)' }}>
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" width="16" height="16" style={{ color: 'var(--primary)' }}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M11.42 15.17 17.25 21A2.652 2.652 0 0 0 21 17.25l-5.877-5.877M11.42 15.17l2.496-3.03c.317-.384.74-.626 1.208-.766M11.42 15.17l-4.655 5.653a2.548 2.548 0 1 1-3.586-3.586l6.837-5.63m5.108-.233c.55-.164 1.163-.188 1.743-.14a4.5 4.5 0 0 0 4.486-6.336l-3.276 3.277a3.004 3.004 0 0 1-2.25-2.25l3.276-3.276a4.5 4.5 0 0 0-6.336 4.486c.091 1.076-.071 2.264-.904 2.95l-.102.085m-1.745 1.437L5.909 7.5H4.5L2.25 3.75l1.5-1.5L7.5 4.5v1.409l4.26 4.26m-1.745 1.437 1.745-1.437m6.615 8.206L15.75 15.75M4.867 19.125h.008v.008h-.008v-.008Z" />
                  </svg>
                </div>
                <span className="service-tag">Most Popular</span>
              </div>
              <h3 className="text-lg font-display font-bold" style={{ color: 'var(--foreground)' }}>Orthopedic Rehabilitation</h3>
              <p className="text-xs leading-relaxed" style={{ color: 'var(--muted-foreground)' }}>
                Targeted recovery for joint replacements, fractures, and musculoskeletal injuries. Personalised exercise programmes to restore full range of motion.
              </p>
            </div>
            <Link href="/contact" className="btn-secondary text-xs mt-4 self-start">Book Now</Link>
          </div>

          {/* Neurological */}
          <div className="bento-card group overflow-hidden">
            <div className="relative h-36 rounded-xl overflow-hidden mb-4 -mx-1 -mt-1">
              <Image
                alt="Physiotherapist supporting patient with neurological rehabilitation and balance training at home"
                src="/assets/images/neuro-1785953141919.jpeg"
                fill
                className="object-cover transition-transform duration-500 group-hover:scale-105"
                sizes="25vw" />
            </div>
            <div className="space-y-2">
              <div className="flex items-center gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" width="16" height="16" style={{ color: 'var(--primary)' }}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 3v1.5M4.5 8.25H3m18 0h-1.5M4.5 12H3m18 0h-1.5m-15 3.75H3m18 0h-1.5M8.25 19.5V21M12 3v1.5m0 15V21m3.75-18v1.5m0 15V21m-9-1.5h10.5a2.25 2.25 0 0 0 2.25-2.25V6.75a2.25 2.25 0 0 0-2.25-2.25H6.75A2.25 2.25 0 0 0 4.5 6.75v10.5a2.25 2.25 0 0 0 2.25 2.25Zm.75-12h9v9h-9v-9Z" />
                </svg>
                <span className="service-tag">Neurological</span>
              </div>
              <h3 className="text-lg font-display font-bold" style={{ color: 'var(--foreground)' }}>Neurological Rehab</h3>
              <p className="text-xs leading-relaxed" style={{ color: 'var(--muted-foreground)' }}>
                Stroke Rehabilitation, Spinal Cord Injury Management, Multiple Sclerosis, Facial Palsy, Gait Training.
              </p>
            </div>
            <Link href="/contact" className="btn-secondary text-xs mt-4 self-start">Book Now</Link>
          </div>

          {/* Post-Surgery */}
          <div className="bento-card dot-pattern group overflow-hidden">
            <div className="relative h-28 rounded-xl overflow-hidden mb-4 -mx-1 -mt-1">
              <Image
                alt="Physiotherapist assisting patient with post-surgery rehabilitation exercises at home"
                src="/assets/images/post_surgical-1785953142890.jpeg"
                fill
                className="object-cover transition-transform duration-500 group-hover:scale-105"
                sizes="20vw" />
            </div>
            <div className="space-y-3">
              <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ backgroundColor: 'var(--secondary)' }}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="20" height="20" style={{ color: 'var(--primary)' }}>
                  <path d="m11.645 20.91-.007-.003-.022-.012a15.247 15.247 0 0 1-.383-.218 25.18 25.18 0 0 1-4.244-3.17C4.688 15.36 2.25 12.174 2.25 8.25 2.25 5.322 4.714 3 7.688 3A5.5 5.5 0 0 1 12 5.052 5.5 5.5 0 0 1 16.313 3c2.973 0 5.437 2.322 5.437 5.25 0 3.925-2.438 7.111-4.739 9.256a25.175 25.175 0 0 1-4.244 3.17 15.247 15.247 0 0 1-.383.219l-.022.012-.007.004-.003.001a.752.752 0 0 1-.704 0l-.003-.001Z" />
                </svg>
              </div>
              <span className="service-tag">Recovery</span>
              <h3 className="text-lg font-display font-bold" style={{ color: 'var(--foreground)' }}>Post-Surgery Rehab</h3>
              <p className="text-xs leading-relaxed" style={{ color: 'var(--muted-foreground)' }}>
                Structured recovery following hip, knee, or shoulder surgery. Coordinated with your surgical team.
              </p>
            </div>
            <Link href="/contact" className="btn-secondary text-xs mt-auto pt-4 self-start">Book Now</Link>
          </div>

          {/* Geriatric */}
          <div className="bento-card group overflow-hidden">
            <div className="relative h-28 rounded-xl overflow-hidden mb-4 -mx-1 -mt-1">
              <Image
                alt="Physiotherapist assisting elderly patient with balance and mobility exercises at home"
                src="/assets/images/geriatric-1785953142319.jpeg"
                fill
                className="object-cover transition-transform duration-500 group-hover:scale-105"
                sizes="20vw" />
            </div>
            <div className="space-y-2">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" width="16" height="16" style={{ color: 'var(--primary)' }}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M18 18.72a9.094 9.094 0 0 0 3.741-.479 3 3 0 0 0-4.682-2.72m.94 3.198.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 0 1 6 18.719m12 0a5.971 5.971 0 0 0-.941-3.197m0 0A5.995 5.995 0 0 0 12 12.75a5.995 5.995 0 0 0-5.058 2.772m0 0a3 3 0 0 0-4.681 2.72 8.986 8.986 0 0 0 3.74.477m.94-3.197a5.971 5.971 0 0 0-.94 3.197M15 6.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm6 3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm-13.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z" />
              </svg>
              <span className="service-tag">Elderly Care</span>
              <h3 className="text-lg font-display font-bold" style={{ color: 'var(--foreground)' }}>Geriatric Physiotherapy</h3>
              <p className="text-xs leading-relaxed" style={{ color: 'var(--muted-foreground)' }}>
                Fall prevention, balance training, strengthening exercises, mobility improvement, arthritis management, osteoporosis exercise programme.
              </p>
            </div>
            <Link href="/contact" className="btn-secondary text-xs mt-auto pt-3 self-start">Book Now</Link>
          </div>

          {/* Cardio Pulmonary */}
          <div className="bento-card group overflow-hidden">
            <div className="relative h-28 rounded-xl overflow-hidden mb-4 -mx-1 -mt-1">
              <Image
                alt="Physiotherapist guiding patient through cardiopulmonary rehabilitation breathing exercises at home"
                src="/assets/images/cardio_pul-1785953142887.jpeg"
                fill
                className="object-cover transition-transform duration-500 group-hover:scale-105"
                sizes="20vw" />
            </div>
            <div className="space-y-3">
              <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ backgroundColor: 'var(--secondary)' }}>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" width="20" height="20" style={{ color: 'var(--primary)' }}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z" />
                </svg>
              </div>
              <span className="service-tag">Cardio Pulmonary</span>
              <h3 className="text-lg font-display font-bold" style={{ color: 'var(--foreground)' }}>Cardio Pulmonary Rehabilitation</h3>
              <p className="text-xs leading-relaxed" style={{ color: 'var(--muted-foreground)' }}>
                Breathing exercises, chest physiotherapy, COPD rehab, incentive spirometry training.
              </p>
            </div>
            <Link href="/contact" className="btn-secondary text-xs mt-auto pt-3 self-start">Book Now</Link>
          </div>

          {/* Pediatrics */}
          <div className="bento-card group overflow-hidden">
            <div className="relative h-28 rounded-xl overflow-hidden mb-4 -mx-1 -mt-1">
              <Image
                alt="Physiotherapist providing pediatric physiotherapy exercises for a child at home"
                src="/assets/images/pediatric_physiotherapy-1785953401151.jpeg"
                fill
                className="object-cover transition-transform duration-500 group-hover:scale-105"
                sizes="20vw" />
            </div>
            <div className="space-y-2">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" width="16" height="16" style={{ color: 'var(--primary)' }}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M15.182 15.182a4.5 4.5 0 0 1-6.364 0M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0ZM9.75 9.75c0 .414-.168.75-.375.75S9 10.164 9 9.75 9.168 9 9.375 9s.375.336.375.75Zm-.375 0h.008v.015h-.008V9.75Zm5.625 0c0 .414-.168.75-.375.75s-.375-.336-.375-.75.168-.75.375-.75.375.336.375.75Zm-.375 0h.008v.015h-.008V9.75Z" />
              </svg>
              <span className="service-tag">Paediatrics</span>
              <h3 className="text-lg font-display font-bold" style={{ color: 'var(--foreground)' }}>Paediatric Physiotherapy</h3>
              <p className="text-xs leading-relaxed" style={{ color: 'var(--muted-foreground)' }}>
                Developmental delay, cerebral palsy, torticollis, and movement disorders in children. Gentle, play-based therapy at home.
              </p>
            </div>
            <Link href="/contact" className="btn-secondary text-xs mt-auto pt-3 self-start">Book Now</Link>
          </div>

          {/* Call CTA - spans 3 cols */}
          <div className="bento-card md:col-span-3 group" style={{ backgroundColor: 'var(--primary)', borderColor: 'var(--primary)', color: 'var(--primary-foreground)' }}>
            <div className="flex flex-col md:flex-row items-center justify-between gap-6">
              <div className="flex items-center gap-5">
                <div className="w-14 h-14 rounded-2xl flex items-center justify-center shrink-0" style={{ backgroundColor: 'rgba(255,255,255,0.1)' }}>
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" width="28" height="28" style={{ color: 'var(--primary-foreground)' }}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 0 1-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25Z" />
                  </svg>
                </div>
                <div>
                  <span className="text-xs font-bold uppercase tracking-widest mb-1 block" style={{ color: 'rgba(255,255,255,0.6)' }}>Direct Line</span>
                  <h3 className="text-xl font-display font-bold" style={{ color: 'var(--primary-foreground)' }}>Call Now — Speak to a Specialist</h3>
                  <p className="text-sm mt-1" style={{ color: 'rgba(255,255,255,0.7)' }}>Get expert advice and book your home visit directly. Our physiotherapists are available to answer your questions.</p>
                </div>
              </div>
              <a href="tel:+919497815224" className="btn-accent shrink-0 px-6 py-3 inline-flex items-center gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" width="15" height="15">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 0 1-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25Z" />
                </svg>
                9497815224
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>);

}